import React from "react";
import LiveChatPopupComponent from "./live-chat-popup-component";
import { AppState } from "../../reducers/models";
import { connect } from "react-redux";
import * as selector from '../../selectors/selectors';
import { useSelector } from "react-redux";

interface IProps {

}

const LiveChatShareToChatLinkComponent: React.FC<IProps> = (props: IProps) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)

    return (
        <div className="w-p-100 h-v-100 d-flex justify-center align-center">
            <LiveChatPopupComponent MobileDevice={IsMobileDevice} IsSharetoChatLink={true} />
        </div>
    )
}


export default LiveChatShareToChatLinkComponent;